import {
	createSlice,
	createAsyncThunk,
	combineReducers,
	configureStore,
} from '@reduxjs/toolkit'
import md5 from 'blueimp-md5'
import store, { ActionParams } from '.'
import { WebStorage } from '@nyanyajs/utils'

import { api } from '../modules/electron/api'
import { storage } from './storage'

export const modeName = 'appearance'

export const appearanceMethods = {
	Init: createAsyncThunk(modeName + '/Init', async (_, thunkAPI) => {
		// 获取配置

		const { config } = store.getState()

		thunkAPI.dispatch(
			appearanceSlice.actions.setMode({
				mode: (await storage.systemConfig.get('mode')) || 'system',
			})
		)
		console.log(
			'nativeThemeChange',
			config.platform,
			await storage.systemConfig.get('mode')
		)
		switch (config.platform) {
			case 'Electron':
				const electron = window.require('electron')
				console.log('nativeThemeChange', electron)
				if (electron) {
					const { ipcRenderer, ipcMain } = electron

					api.getMode()
				}
				break
			case 'Web':
				break

			default:
				break
		}
	}),
	SetMode: createAsyncThunk(
		modeName + '/SetMode',
		async (mode: 'dark' | 'light' | 'black' | 'system', thunkAPI) => {
			const { config } = store.getState()
			console.log('nativeThemeChange', config.platform, mode)
			switch (config.platform) {
				case 'Electron':
					const electron = window.require('electron')
					if (electron) {
						const { ipcRenderer, ipcMain } = electron

						api.setMode(mode)
						thunkAPI.dispatch(
							appearanceSlice.actions.setMode({
								mode: mode,
							})
						)
					}
					break
				case 'Web':
					thunkAPI.dispatch(
						appearanceSlice.actions.setMode({
							mode: mode,
						})
					)
					break

				default:
					break
			}
			// thunkAPI.dispatch(
			// 	appearanceSlice.actions.setMode({
			// 		mode: window.matchMedia('(prefers-color-scheme: dark)').matches
			// 			? 'dark'
			// 			: 'light',
			// 	})
			// )
			// const electron = window.require('electron')
			// if (electron) {
			// 	const { ipcRenderer, ipcMain } = electron
			// 	ipcRenderer.addListener('nativeThemeChange', (event, arg) => {
			// 		thunkAPI.dispatch(
			// 			appearanceSlice.actions.setMode({
			// 				mode: arg,
			// 			})
			// 		)
			// 	})
			// }
		}
	),
}

type Mode = 'dark' | 'light' | 'black' | 'system'

export const appearanceSlice = createSlice({
	name: modeName,
	initialState: {
		mode: 'system',
	},
	reducers: {
		setMode: (
			state,
			params: ActionParams<{
				mode: Mode
			}>
    ) => {
      state.mode = params.payload.mode
      
      
			localStorage.setItem('appearanceMode', state.mode)
			storage.systemConfig.setSync('mode', params.payload.mode)

			console.log(
				'nativeThemeChange',
				storage.systemConfig.get('mode').then((v) => console.log(v))
      )
      

			document.body.classList.remove(
				'system-mode',
				'dark-mode',
				'black-mode',
				'light-mode'
			)
			document.body.classList.add(state.mode + '-mode')

			const themeColorEl = document.head.querySelector(
				"meta[name='theme-color']"
      )
			if (themeColorEl) {
				if (state.mode === 'dark') {
					themeColorEl.setAttribute('content', '#1e1e1e')
				}
				if (state.mode === 'black') {
					themeColorEl.setAttribute('content', '#000')
				}
				if (state.mode === 'light') {
					themeColorEl.setAttribute('content', '#fff')
				}
			}

			// api.showNotification({
			//   title: t('copySuccessfully', {
			//     ns: 'common',
			//   }),
			//   content: sv.content || '',
			// })
		},
	},
})
